import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col justify-center items-center h-full"
}
const _hoisted_3 = { class: "text-red-500 mb-4" }

import { useTask } from "@/composables/tasks/useTask";
import { useRoute } from "vue-router";
import { normalizeRouteParam } from "@/utils/v2/routes";
import { TasksService } from "@/services/v2/tasks";
import { useTasksStore } from "@/stores/v2";
import { onMounted, ref } from "vue";

import LayoutMain from '@/components/v2/Layouts/LayoutMain.vue';
import TaskAnimalTransfer from '@/components/v2/Tasks/AnimalTransfer/index.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AnimalTransferTaskPage',
  setup(__props) {

const { startObserver } = useTask();
const route = useRoute();
const taskKey = normalizeRouteParam(route.params.key);

const isLoading = ref(true);
const error = ref('');

const initTask = async () => {
  isLoading.value = true;
  error.value = '';

  if (!taskKey) {
    error.value = 'Invalid task key';
    isLoading.value = false;
    return;
  }

  try {
    const task = await TasksService.startTask(taskKey);
    if (!task) {
      error.value = 'Task not found';
      isLoading.value = false;
      return;
    }
    await useTasksStore().setActiveTask(task);
    startObserver();
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to load task';
  } finally {
    isLoading.value = false;
  }
};

const handleRetry = () => {
  initTask();
};

onMounted(initTask);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutMain, null, {
    mainArea: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary" }, null, -1)
          ])))
        : (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(error.value), 1),
              _createElementVNode("button", {
                onClick: handleRetry,
                class: "px-4 py-2 bg-primary text-white rounded"
              }, "Retry")
            ]))
          : (_openBlock(), _createBlock(TaskAnimalTransfer, { key: 2 }))
    ]),
    _: 1
  }))
}
}

})